<div
  #wrapper
  class="bc-panel bc-layout-wrapper nanorep-panel"
  [ngClass]="{ 'knowledge-base-inline': !isExpanded }"
  [hidden]="!isOpened"
>
  <div class="knowledge-base-panel">
    <div class="knowledge-base-top-bar" #headNode>
      <div class="knowledge-base-header-title">
        <svg-icon icon="smart-advisor"></svg-icon>
        <span>Smart Advisor</span>
      </div>
    </div>

    <div #mountNode></div>
  </div>
</div>
